<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="物流信息维护"
      width="1000px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="outStock"
        class="form"
        label-width="110px"
        style="height: 200px;">
      <el-row>
        <el-col :span="24">
          <el-form-item label="物流公司">
            <el-select v-model="outStock.transferCompany">
              <el-option label="广昌县恒达（彤宏）物流有限公司" value="广昌县恒达（彤宏）物流有限公司" default/>
              <el-option label="上海凯亿（中通快运）实业有限公司" value="上海凯亿（中通快运）实业有限公司"/>
              <el-option label="上海顺衡（顺丰）物流有限公司" value="上海顺衡（顺丰）物流有限公司"/>
              <el-option label="上海速以达（安能）物流有限公司" value="上海速以达（安能）物流有限公司"/>
              <el-option label="上海骏智（中通快递）物料有限公司" value="上海骏智（中通快递）物料有限公司"/>
              <el-option label="上海领速（跨越）物流有限公司" value="上海领速（跨越）物流有限公司"/>
              <el-option label="自送" value="自送"/>
              <el-option label="客户自提" value="客户自提"/>
              <el-option label="上海截顺（韵达）货运代理有限公司" value="上海截顺（韵达）货运代理有限公司"/>
              <el-option label="中通快运" value="中通快运"/>
              <el-option label="中通快递" value="中通快递"/>
              <el-option label="安能物流" value="安能物流"/>
              <el-option label="壹米滴答" value="壹米滴答"/>
              <el-option label="顺丰" value="顺丰"/>
              <el-option label="跨越" value="跨越"/>
              <el-option label="其它" value="其它"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="物流编号">
            <el-input v-model="outStock.transferNo" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="重量">
            <el-input v-model="outStock.transferWeight" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="height: 50px">
        <el-col :span="24">
          <el-form-item label="描述">
            <el-input
                v-model="outStock.transferNote"
                type="textarea"
                style="height: 50px;"
                autosize
                placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        disabled: "",
        outStock: {
          pkId: 0,
          transferCompany: "广昌县恒达（彤宏）物流有限公司",
          transferWeight: "",
          transferNo: "",
          transferNote: "",
        },
      };
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.outStock = row;
        }
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {

            this.submitLoading = true;
            this.$http
                .post("basic", "outStockDeliverys/transferEdit", this.outStock)
                .then((resp) => {
                  this.submitLoading = false;
                  if (resp.success) {
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                    this.dialogVisible = false;
                  } else {
                    this.$message.error(resp.message);
                  }
                })
                .catch(() => {
                  this.submitLoading = false;
                });

          }
        });
      },

    },
  };
</script>

<style lang="scss" scoped>
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
  padding-bottom: 5px;
}
</style>
